export default function RepairNotReplace() {
  return (
    <section className="bg-plum py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto text-center">
          <p className="font-serif italic text-rose-200 text-sm md:text-base mb-3">
            Économique et écologique
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
            <span className="font-serif italic">Réparer</span> plutôt que remplacer la fenêtre
          </h2>
          <p className="text-base md:text-lg text-rose-100 leading-relaxed mb-8 max-w-2xl mx-auto">
            Changer une fenêtre complète, même en PVC standard, coûte entre 800 et 1 500 € l'unité avec la pose. Le remplacement de la crémone coûte une fraction de ce prix. Chez DF PRO, nous remplaçons uniquement la pièce usée — la crémone, un galet, un crochet — et laissons la menuiserie intacte. Vous gardez votre fenêtre, son aspect, son isolation, et vous économisez plusieurs centaines d'euros. C'est aussi une démarche écologique : pas de déchets, pas de transport de nouvelle menuiserie, pas de perturbation de votre intérieur.
          </p>
          <a
            href="tel:0374471036"
            className="inline-flex items-center gap-2 bg-coral text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-coral-light transition-colors"
          >
            <i className="ri-phone-line" />
            Appeler le 03 74 47 10 36
          </a>
        </div>
      </div>
    </section>
  );
}